import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'ellipsis'})
export class EllipsisPipe implements PipeTransform {
  transform(text: string, length: number) {
    if (!text) {
      return '';
    }
    if (!length) {
      if (text.length < 25) {
        return text;
      }
      return text.substr(0, 25) + '...';
    }
    if (text.length < length) {
      return text;
    }
    return text.substr(0, length) + '...';
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/pipes/ellipsis.ts